<template>
  <div class="account-invitation-container c-app flex-row align-items-center">
    <CContainer>
        <CRow class="justify-content-center">
            <CCol md="8">
                <CCardGroup>
                    <CCard class="p-4">
                        <CCardBody>
                            <h3 class="text-center text-underline mb-4">みまもりサービスBASICプランへの招待​</h3>
                            <p>現在、以下のアカウントでサービスにログインしています。​</p>

                            <p class="mb-1 mt-4">現在のアカウントのメールアドレス​</p>
                            <CCard class="p-2">
                                <ul class="m-0">
                                    <li>{{ currentEmail }}</li>
                                </ul>
                            </CCard>
                            <p>新しく招待されたアカウントのメールアドレスは、以下です。​</p>
                            
                            <p class="mb-1 mt-4">招待されたメールアドレス​</p>
                            <CCard class="p-2">
                                <ul class="m-0">
                                    <li>{{ invitedEmail }}</li>
                                </ul>
                            </CCard>
                            <p class="mb-1">新しく招待されたメールアドレスでサービスをご利用になる場合は、</p>
                            <p class="mb-4">以下のボタンをクリックしてください。</p>
                            <CRow>
                                <CCol col="12" class="text-center">
                                    <CButton 
                                        @click="transitionProcess()"
                                        color="danger"
                                        class="px-4"
                                    >
                                        ログアウトして招待されたアカウントに切り替える
                                    ​</CButton>
                                </CCol>
                            </CRow>
                        </CCardBody>
                    </CCard>
                </CCardGroup>
            </CCol>
        </CRow>
    </CContainer>
  </div>
</template>
<script>
export default {
    name: 'AnotherAccountInvitation',

    data () {
        return {
            currentEmail: 'aaa@email.com',
            invitedEmail: 'bbb@email.com'
        }
    },
    methods: {
        transitionProcess (){
            this.$router.push('/')
        }
    }
}
</script>